import { Component } from '@angular/core';
import { GridModule } from '@coreui/angular';
import { IconModule } from '@coreui/icons-angular';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { OS } from '@smarsh-cyber/shared/models';
import { getOSData } from '@smarsh-cyber/shared/utils';

@Component({
  selector: 'smarsh-aggrid-os',
  standalone: true,
  imports: [GridModule, IconModule],
  templateUrl: './aggrid-os.component.html',
  styles: ''
})
export class AggridOsComponent implements ICellRendererAngularComp {
  info: OS = {
    title: 'Error',
    icon: 'cil-crop'
  };
  agInit(params: ICellRendererParams): void {
    this.setIconInfo(params);
  }
  refresh(params: ICellRendererParams): boolean {
    this.setIconInfo(params);
    return true;
  }

  setIconInfo(params) {
    this.info = getOSData(params.value);
  }
}
